import { trpc } from "../../main/components/trpc.ts";

const OnlineUsers = () => {
  const { data: users } = trpc.user.getOnlineUsers.useQuery();

  return users ? (
    <div className="clear-both mx-2.5 my-2.5 overflow-hidden p-0.75 bg-[#f3f3f3] border border-solid border-[#bcbcbc] rounded-[3px] font-[Roboto,Arial,sans-serif] font-light">
      {users.map((user) => (
        <span
          className={`text-[0.9em] text-white text-center m-0.75 w-[3em] p-0.75 uppercase ${
            user.tag === "doctor" ? "bg-orange-500" : "bg-green-600"
          }`}
          key={"OnlineUserKey" + user.id}
        >
          {user.messagename}
        </span>
      ))}
    </div>
  ) : null;
};

export default OnlineUsers;
